export default "/" + Playtech.Variables.themeName + "/js/app-out/img/js__hooks__games__images__game_placeholder.svg" + window.location.search;